import { FETCH_COUNTRIES_FOR_PROJECT_TYPE } from '../../constants/actionTypes'

export default (countriesForProjectType = [], action) => {
    switch (action.type) {
        case FETCH_COUNTRIES_FOR_PROJECT_TYPE:
            return action.payload;
        default:
            return countriesForProjectType;
    }
}